import axios from 'axios';
import {AppConfig} from '@/config/AppConfig';


let headers = {
  
    'Accept':'application/json',
    'x-client-id':'gongcha',
    'x-secret-key':'AAAA',
}

const API_PREFIX = '/app/api/v1'

var client = axios.create({
  baseURL:AppConfig.VUE_APP_API_DOMAIN + API_PREFIX,
  headers : headers
})



const requestPost =  (method,url,data, showConsole) => {
  return new Promise(async (resolve,reject) => {

    let full_url = AppConfig.VUE_APP_API_DOMAIN + API_PREFIX + url;
    if(data && showConsole)console.log(`Axios.requestPost => method:${method},url:${full_url},data:${JSON.stringify(data)}`);
    
      return client ({ 
        method: method, 
        url: full_url, 
        data,
        timeout:10000,
        headers:headers
      })  
    .then(result => {
      if (showConsole)console.log(`Axios.requestPost => result:${JSON.stringify(result)}`);    
      resolve(result.data)
    }) 
    .catch(err => {       
      reject(err)
    }) 
  })
}


const requestGet = (method,url,params, showConsole) => {

  return new Promise(async (resolve,reject) => {
    let full_url = AppConfig.VUE_APP_API_DOMAIN + API_PREFIX + url;    
    if(params && showConsole)console.log(`Axios.requestGet => method:${method},url:${full_url}, params:${JSON.stringify(params)}`);    
      return client ({ 
        method: method, 
        url: full_url, 
        params:params,
        timeout:10000,
        headers:headers
      })  
    .then(result => {
      if (showConsole)console.log(`Axios.requestGet => result:${JSON.stringify(result)}`);    
      // return result.data
      resolve(result.data)
    }) 
    .catch(err => { 
      
      reject(err)  
    }) 
  })
}

const interceptors = (a) => {
  return new Promise(async(resolve,reject) => {

    return axios.interceptors.response.use()
    .then(result => resolve(result))
    .catch(err => {
      reject(err)
    })



  //   return axios.interceptors.response.use(response => {
  //     resolve(response)
  //     return response;
  //   }, error => {

  //     reject(error)
  //     if (error.response.status === 401) {
  //       //place your reentry code
        
  //     }
  //     return error;
  //  })  
})}

//
export const Axios = {
  
  get(url,params, showConsole = true){
    return requestGet('get',url,params, showConsole);
  }
  ,post(url,data, showConsole = true){
    return requestPost('post',url,data, showConsole);
  },
  setAccessToken(token){
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
  },
  removeAccessToken(){
    console.log('Axios.removeAccessToken');
    // delete axios.defaults.headers.common["Authorization"];
    delete headers.Authorization;
  },
  getAxios(){
    return axios()
  },
  setInterceptors(a){
    return interceptors(a);
  },
  client
  
}
//set header token
var Authorization;
export const setAuthToken = token => {  
  // console.log('Axios.setAuthToken => ' ,token);
  // Authorization = `Bearer ${token}`
  headers.Authorization = `Bearer ${token}`
  // axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
}



// WEBPACK FOOTER //
// ./src/api/Axios.js